function figmaCleanSectionTitle(headingEl) {
  var clone = headingEl.cloneNode(true);
  var hadHighlight = !!clone.querySelector('.highlight');
  clone.querySelectorAll('.highlight').forEach(function (n) {
    n.remove();
  });
  var text = clone.textContent.replace(/\s+/g, ' ').trim();
  text = text.replace(/:\s*$/, '').trim();
  if (hadHighlight) {
    text = text.replace(/\s+(for|of)$/i, '').trim();
  }
  return text;
}

function figmaEscapeHtml(str) {
  var div = document.createElement('div');
  div.textContent = str;
  return div.innerHTML;
}

function figmaCollapsibleHtml(title, bodyHtml) {
  return (
    '<collapsible-block tabindex="0" class="bls-toggle relative border-bottom block">' +
    '<h3 class="h6 my-0 pointer py-17 relative collapsible-heading heading-letter-spacing">' +
    figmaEscapeHtml(title) +
    '<span class="open-children-toggle absolute inset-0 flex flex-end pointer"><span class="icon_plus-animation"> </span></span>' +
    '</h3>' +
    '<div class="overflow-hidden collapsible-content" style="display: none;">' +
    '<div class="collapsible-content_inner mb-12 rich__text-mt-0">' +
    bodyHtml +
    '</div></div></collapsible-block>'
  );
}

// The description is a series of .section blocks. Key benefits, key ingredients,
// best for (and anything else) stay inside the Product Details row as sub-headed
// parts; How to Use and the "... Routine Step" section move into one How to Use row.
function figmaSplitDescriptionIntoDropdowns(mainSection) {
  var descriptionBlock = mainSection.querySelector('.collapsible-content_inner.product_description .product-description');
  if (!descriptionBlock) return;
  var anchorBlock = descriptionBlock.closest('collapsible-block');
  if (!anchorBlock) return;

  var sections = Array.from(descriptionBlock.querySelectorAll(':scope > .section'));
  if (sections.length === 0) return;

  var howToUse = [];
  var routine = [];
  sections.forEach(function (sectionEl) {
    var titleEl = sectionEl.querySelector('.section-title');
    if (!titleEl) return;
    var title = figmaCleanSectionTitle(titleEl);
    if (!title) return;

    if (/^how to use/i.test(title)) {
      titleEl.remove();
      howToUse.push(sectionEl);
    } else if (/routine/i.test(title)) {
      titleEl.textContent = 'Routine Step';
      routine.push(sectionEl);
    } else {
      titleEl.textContent = title;
    }
  });

  var moved = howToUse.concat(routine);
  if (moved.length === 0) return;
  // With no How to Use section, the routine section is the row's only content
  // and the row is named after it.
  var rowTitle = howToUse.length ? 'How to Use' : 'Routine Step';
  if (!howToUse.length) routine[0].querySelector('.section-title').remove();

  var body = moved
    .map(function (el) {
      el.remove();
      return el.outerHTML;
    })
    .join('');
  anchorBlock.insertAdjacentHTML('afterend', figmaCollapsibleHtml(rowTitle, '<div class="product-description">' + body + '</div>'));
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="MainProduct-"]').forEach(function (section) {
    figmaSplitDescriptionIntoDropdowns(section);

    var media = section.querySelector('.media-main-swiper') || section.querySelector('.product-detail__media');
    var saleBadge = section.querySelector('.sale_badge');
    var authenticity = section.querySelector('.product-detail__custom-liquid');
    if (media && (saleBadge || authenticity)) {
      var wrap = document.createElement('div');
      wrap.className = 'figma-image-badges';
      if (saleBadge) wrap.appendChild(saleBadge);
      if (authenticity) wrap.appendChild(authenticity);
      media.appendChild(wrap);
    }

    var mount = section.querySelector('[data-figma-reviews-mount]');
    if (mount) {
      var widgetSection = document.querySelector('[id$="__1784038963a2636924"]');
      var widgetBlock = widgetSection ? widgetSection.querySelector(':scope > .shopify-block') : null;
      if (widgetBlock) {
        mount.innerHTML = '';
        mount.appendChild(widgetBlock);
        widgetSection.style.display = 'none';
      } else {
        var reviewsLink = mount.querySelector('[data-figma-see-all-reviews]');
        if (reviewsLink) {
          reviewsLink.addEventListener('click', function () {
            if (widgetSection) {
              widgetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });
        }
      }
    }
  });

  document.querySelectorAll('more-from-brand').forEach(function (el) {
    var vendor = el.getAttribute('data-vendor');
    if (!vendor || !el.querySelector('.figma-more-from-brand__items')) return;

    // The row sits far below the fold: fetch only when the shopper scrolls near it.
    // The element itself is display:none until filled, so watch its section wrapper.
    var target = el.parentElement || el;
    if (!('IntersectionObserver' in window)) {
      figmaLoadMoreFromBrand(el);
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        figmaLoadMoreFromBrand(el);
      },
      { rootMargin: '0px 0px 600px 0px' }
    );
    observer.observe(target);
  });
});

function figmaLoadMoreFromBrand(el) {
  var vendor = el.getAttribute('data-vendor');
  var currentUrl = el.getAttribute('data-current-url');
  var limit = parseInt(el.getAttribute('data-limit'), 10) || 8;
  var grid = el.querySelector('.figma-more-from-brand__items');

  // Section Rendering API: only the cards (sections/more-from-brand-items.liquid),
  // not the whole search page.
  var query = 'vendor:"' + vendor + '"';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(root + 'search?q=' + encodeURIComponent(query) + '&type=product&section_id=more-from-brand-items')
    .then(function (res) {
      if (!res.ok) throw new Error(res.status);
      return res.text();
    })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cards = Array.from(doc.querySelectorAll('.product-item'));
      var seen = {};
      var added = 0;
      cards.forEach(function (card) {
        if (added >= limit) return;
        var link = card.querySelector('a[href*="/products/"]');
        var href = link ? link.getAttribute('href').split('?')[0] : null;
        if (!href || href === currentUrl || seen[href]) return;
        seen[href] = true;
        added += 1;
        grid.appendChild(card);
      });
      if (added > 0) {
        el.classList.remove('hidden');
      } else {
        el.remove();
      }
    })
    .catch(function () {
      el.remove();
    });
}
